(function() { module.exports = this["tinymce"]; }());